import type { FC } from 'react';
import { memo, useEffect } from 'react';
import clsx from 'clsx';
import { useSetUXFParameters } from 'UXF/hooks/useSetUXFParameters';

import { useCurrentUserStore } from 'store/currentUser';
import { useSizeStore } from 'store/size';

import { useDeviceWidth } from 'hooks/useDeviceWidth';

import Controls from '../Bottom/Controls';
import CameraTutorialModal from '../Bottom/Controls/CameraTutorialModal';
import Screen from './Screen';
import MainScreenPartContext from './Screen/MainScreenPartContext';
import styles from './styles.module.scss';
import Users from './Users';

const Body: FC = () => {
    const { isFull } = useSizeStore();
    const { initManageMicrophoneLevel } = useCurrentUserStore();
    const { isDesktop, isLandscape } = useDeviceWidth();
    const renderControls = isLandscape && !isDesktop && !isFull;

    useSetUXFParameters();

    useEffect(() => {
        initManageMicrophoneLevel();
    }, []);

    return (
        <div className={clsx(styles.wrapper, { [styles.wrapperIsFull]: isFull })}>
            <MainScreenPartContext>
                <Screen />
                {renderControls && <Controls />}
                {!isFull && <Users />}
                <CameraTutorialModal />
            </MainScreenPartContext>
        </div>
    );
};

export default memo(Body);
